/*
  Shared TPG product-card behaviour: size-range pill + AS Colour swatch chips
  (with variant-image swap and a "+N" popup).

  Used by the collection grid (collectiongridpro) and the home-page carousel
  (collectionproducts) so both cards behave identically.

  Markup contract (data attributes, so any class naming works):
    [data-tpg-card]                       card root
    [data-tpg-main-img]                   the main <img> to swap on chip hover/click
    [data-tpg-sizes]   data-sizes='[...]' element to fill with e.g. "XS TO 5XL"
    [data-tpg-swatches] data-colours='[...]' data-images='{name:url}'

  Chips carry both cgp-* and tpgc-* classes so each section can style them
  with its own CSS without needing to share a stylesheet.
*/
window.TPGCard = (function () {
  var MAX_CHIPS = 5;
  var SIZE_RANK = { 'XXXS': -2, 'XXS': -1, 'XS': 0, 'S': 1, 'M': 2, 'L': 3, 'XL': 4, 'XXL': 5, '2XL': 5, 'XXXL': 6, '3XL': 6, '4XL': 7, '5XL': 8, '6XL': 9, '7XL': 10 };

  function norm(s) { return (s || '').toString().trim().toLowerCase(); }

  function sizeRank(s) {
    var k = norm(s).toUpperCase().replace(/\s+/g, '');
    if (SIZE_RANK[k] !== undefined) return SIZE_RANK[k];
    var n = parseFloat(k);
    if (!isNaN(n)) return 100 + n;
    return 999;
  }

  // Reads the inline palette JSON shipped by snippets/ascolour-palette.liquid
  function palette() {
    var map = {}, famMap = {};
    try {
      var node = document.getElementById('cgp-ascolour-palette');
      if (node) {
        var cols = JSON.parse(node.textContent).colours || [];
        cols.forEach(function (c) {
          if (c && c.name) { map[norm(c.name)] = c.hex; famMap[norm(c.name)] = c.family; }
        });
      }
    } catch (e) {}
    return { map: map, famMap: famMap };
  }

  // Swapping only `src` does nothing while a matching `srcset` candidate exists,
  // so set/restore both. (The home carousel ships a srcset; the collection grid doesn't.)
  function remember(img) {
    if (!img) return;
    if (!img.dataset.orig) img.dataset.orig = img.getAttribute('src') || '';
    if (img.dataset.origSrcset === undefined) img.dataset.origSrcset = img.getAttribute('srcset') || '';
  }
  function showImg(img, url) {
    if (!img || !url) return;
    remember(img);
    img.setAttribute('srcset', url);
    img.setAttribute('src', url);
  }
  function restoreImg(img) {
    if (!img) return;
    if (img.dataset.cur) { showImg(img, img.dataset.cur); return; }
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    else img.removeAttribute('srcset');
    if (img.dataset.orig) img.setAttribute('src', img.dataset.orig);
  }

  // Two-tone colourways ("WHITE/RED" on ringers, stripes, raglans) have no single
  // hex, so they used to fall through to the grey-beige fallback — three white
  // ringers rendered as three identical blobs. Split the name and draw a 50/50
  // diagonal instead. Returns null unless BOTH tones resolve, so anything
  // unrecognised keeps the previous single-colour behaviour.
  function twoToneBg(name, map) {
    if (!name || !map) return null;
    var parts = String(name).split('/');
    if (parts.length !== 2) return null;
    var a = map[norm(parts[0])], b = map[norm(parts[1])];
    if (!a || !b) return null;
    return 'linear-gradient(135deg, ' + a + ' 0 50%, ' + b + ' 50% 100%)';
  }

  function chip(name, hex, ctx) {
    var s = document.createElement('span');
    s.className = 'cgp-sw tpgc-sw';
    var split = twoToneBg(name, ctx && ctx.map);
    if (split) s.classList.add('cgp-sw--split', 'tpgc-sw--split');
    s.style.background = split || hex || '#e3ddd0';
    s.title = name || '';
    if (ctx && ctx.img && ctx.imgMap && ctx.imgMap[name]) {
      s.style.cursor = 'pointer';
      s.addEventListener('mouseenter', function () { showImg(ctx.img, ctx.imgMap[name]); });
      s.addEventListener('mouseleave', function () { restoreImg(ctx.img); });
      s.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ctx.img.dataset.cur = ctx.imgMap[name];
        showImg(ctx.img, ctx.imgMap[name]);
      });
    }
    return s;
  }

  var popEl = null;
  function ensurePop() {
    if (popEl) return popEl;
    popEl = document.createElement('div');
    popEl.className = 'cgp-swpop tpgc-swpop';
    popEl.innerHTML = '<div class="cgp-swpop__grid tpgc-swpop__grid"></div>';
    document.body.appendChild(popEl);
    document.addEventListener('click', function (e) { if (popEl.classList.contains('is-open') && !popEl.contains(e.target)) closePop(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
    window.addEventListener('resize', closePop);
    window.addEventListener('scroll', closePop, true);
    return popEl;
  }
  function closePop() { if (popEl) popEl.classList.remove('is-open'); }

  function openPop(btn, names, map, ctx) {
    var p = ensurePop();
    var grid = p.querySelector('.tpgc-swpop__grid');
    grid.innerHTML = '';
    names.forEach(function (n) { grid.appendChild(chip(n, map[norm(n)], ctx || { map: map })); });
    p.classList.add('is-open');
    var r = btn.getBoundingClientRect();
    var left = Math.max(12, Math.min(r.left, window.innerWidth - p.offsetWidth - 12));
    var top = r.bottom + 8;
    if (top + p.offsetHeight > window.innerHeight - 12) top = Math.max(12, r.top - p.offsetHeight - 8);
    p.style.left = left + 'px';
    p.style.top = top + 'px';
  }

  function renderSizes(scope) {
    (scope || document).querySelectorAll('[data-tpg-sizes]').forEach(function (el) {
      var sizes; try { sizes = JSON.parse(el.dataset.sizes || '[]'); } catch (e) { sizes = []; }
      sizes = sizes.filter(Boolean);
      if (!sizes.length) { el.textContent = ''; return; }
      var sorted = sizes.slice().sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
      var lo = sorted[0], hi = sorted[sorted.length - 1];
      el.textContent = (lo === hi) ? String(lo).toUpperCase() : (String(lo) + ' to ' + String(hi)).toUpperCase();
    });
  }

  function renderSwatches(scope, map, maxChips) {
    var limit = maxChips || MAX_CHIPS;
    (scope || document).querySelectorAll('[data-tpg-swatches]').forEach(function (el) {
      var names; try { names = JSON.parse(el.dataset.colours || '[]'); } catch (e) { names = []; }
      var imgMap; try { imgMap = JSON.parse(el.dataset.images || '{}'); } catch (e) { imgMap = {}; }
      names = names.filter(Boolean);
      var card = el.closest('[data-tpg-card]');
      var mainImg = card ? card.querySelector('[data-tpg-main-img]') : null;
      remember(mainImg);
      var ctx = { img: mainImg, imgMap: imgMap, map: map };
      el.innerHTML = '';
      names.slice(0, limit).forEach(function (n) { el.appendChild(chip(n, map[norm(n)], ctx)); });
      if (names.length > limit) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'cgp-sw--more tpgc-sw--more';
        more.textContent = '+' + (names.length - limit);
        more.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          openPop(more, names, map, ctx);
        });
        el.appendChild(more);
      }
    });
  }

  function init(scope, maxChips) {
    var p = palette();
    renderSizes(scope);
    renderSwatches(scope, p.map, maxChips);
    return p;
  }

  return {
    norm: norm,
    sizeRank: sizeRank,
    palette: palette,
    chip: chip,
    renderSizes: renderSizes,
    renderSwatches: renderSwatches,
    init: init
  };
})();
